import React, { useState } from 'react';
import DigiportIssues from 'src/components/DigiportIssues';
import axios from 'src/utils/axios';
import logger from 'src/utils/logger';

const Digiport = () => {
  const [loading, setLoading] = useState(false);
  const [issues, setIssues] = useState([]);

  React.useEffect(() => {
    let isMounted = true;
    setLoading(true);

    axios.get('/GetArtemisDigiportSearch')
      .then(response => {
        if (isMounted) {
          setIssues(response.data !== "" && response.data.total && response.data.total > 0 ? response.data.issues : []);
          setLoading(false);
        }
      })
      .catch(error => {
        if (isMounted) {
          setLoading(false);
        }
        logger.error("Digiport tickets error:", error.message);
      });

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, []);

  return (
    <DigiportIssues issues={issues} loading={loading} />
  );
}

export default Digiport;